!function () {
  "use strict";

  function focusElement(el, focusFirst = true) {
    if (!el) throw new Error("要素が見つかりませんでした");
    const focusable = getFocusableElements(el);
    if (focusable.length > 0) {
      focusable[focusFirst ? 0 : focusable.length - 1].focus();
    }
    focusable[0].focus();
  }

  function getFocusableElements(el) {
    const elements = el.querySelectorAll("button, a");
    return Array.from(elements);
  }

  const body = document.body;
  // document.getElementById("js-header");
  // document.getElementById("js-hamburgerBtn");
  // document.getElementById("js-fullScreenOverlay");
  // document.getElementById("js-floatingMenu");
  // document.getElementById("js-toTop");

  const SCROLLABLE_CLASS = "js-canScroll";

  function handleTouchMove(e) {
    const target = e.target?.closest(SCROLLABLE_CLASS);
    if (target !== null && target) {
      if (target.clientHeight < target.scrollHeight) {
        e.stopPropagation();
      } else {
        e.preventDefault();
      }
    }
  }

  function preventScrollLockEdge(e) {
    const el = e.target;
    if (el !== null) {
      if (el.scrollTop + el.clientHeight === el.scrollHeight) {
        el.scrollTop = el.scrollTop - 1;
      }
      if (el.scrollTop === 0) {
        el.scrollTop = 1;
      }
    }
  }

  function isWindows() {
    return window.navigator.userAgent.toLowerCase().includes("windows nt");
  }

  let scrollY = 0;

  // AOS.init();

  const modal = document.getElementById("js-globalActivitiesModal");

  function onModalKeyDown(e) {
    handleKeyDownInsideModal(e, modal, closeModal);
  }

  function handleKeyDownInsideModal(event, modalEl, onClose) {
    if (!modalEl) return;

    switch (event.code) {
      case "Enter":
      case "Space":
        break;
      case "Escape":
        onClose();
        break;
      case "Tab":
        const focusable = getFocusableElements(modalEl);
        const activeIndex = focusable.findIndex(el => el === document.activeElement);

        if (focusable.length === 1) {
          event.preventDefault();
          event.stopImmediatePropagation();
          focusElement(modalEl, true);
          break;
        }

        if (activeIndex === 0 && event.shiftKey) {
          event.preventDefault();
          event.stopImmediatePropagation();
          focusElement(modalEl, false);
        } else if (activeIndex >= focusable.length - 1 && !event.shiftKey) {
          event.preventDefault();
          event.stopImmediatePropagation();
          focusElement(modalEl, true);
        } else if (activeIndex === -1) {
          focusElement(modalEl, true);
        }
        break;
    }
  }

  function initializeGlobalActivitiesModal() {
    const thumbSwiper = new Swiper("#js-globalActivitiesModalThumb", {
      slidesPerView: 4,
      spaceBetween: 8,
      loop: true,
      breakpoints: {
        640: {
          slidesPerView: 7,
          spaceBetween: 18
        }
      },
      navigation: {
        prevEl: "#js-globalActivitiesModalThumb .swiper-button-prev",
        nextEl: "#js-globalActivitiesModalThumb .swiper-button-next"
      }
    });

    const mainSwiper = new Swiper("#js-globalActivitiesModalMain", {
      slidesPerView: 1,
      effect: "fade",
      fadeEffect: {
        crossFade: true
      },
      thumbs: {
        swiper: thumbSwiper
      }
    });

    const triggers = document.getElementsByClassName("js-globalActivitiesShowModal");
    for (let i = 0; i < triggers.length; i++) {
      triggers[i].addEventListener("click", showModal.bind(triggers[i]), false);
    }

    const closeBtn = document.getElementById("js-globalActivitiesModalClose");
    if (closeBtn) {
      closeBtn.addEventListener("click", closeModal, false);
    }

    const overlay = document.getElementById("js-overlay");
    if (overlay) {
      overlay.addEventListener("click", closeModal, false);
    }

    function showModal() {
      const index = this.dataset.index;
      const modal = document.getElementById("js-globalActivitiesModal");
      // const overlay = document.getElementById("js-overlay");

      modal.setAttribute("aria-hidden", false);
      // overlay.setAttribute("aria-hidden", false);

      mainSwiper.slideTo(index, 100);

      window.addEventListener("keydown", onModalKeyDown, { capture: true });
      document.addEventListener("touchmove", handleTouchMove, { passive: false });

      lockScroll(modal);
      focusElement(modal);
    }
  }

  function closeModal() {
    const modal = document.getElementById("js-globalActivitiesModal");
    // const overlay = document.getElementById("js-overlay");

    modal.setAttribute("aria-hidden", true);
    // overlay.setAttribute("aria-hidden", true);

    window.removeEventListener("keydown", onModalKeyDown, { capture: true });
    document.removeEventListener("touchmove", handleTouchMove);

    unlockScroll(modal);
    document.body.focus();
  }

  function lockScroll(modalEl) {
    if (isWindows()) {
      scrollY = document.documentElement.scrollTop || body.scrollTop;
      body.classList.add("scroll-lock-windows");
      body.style.top = `-${scrollY}px`;
    } else {
      body.classList.add("scroll-lock");
    }

    const scrollTarget = modalEl.querySelector(`.${SCROLLABLE_CLASS}`);
    if (scrollTarget) {
      scrollTarget.addEventListener("scroll", preventScrollLockEdge);
    }
  }

  function unlockScroll(modalEl) {
    if (isWindows()) {
      body.classList.remove("scroll-lock-windows");
      body.style.top = "initial";
      body.scrollTop = scrollY;
      document.documentElement.scrollTop = scrollY;
    } else {
      body.classList.remove("scroll-lock");
    }

    const scrollTarget = modalEl.querySelector(`.${SCROLLABLE_CLASS}`);
    if (scrollTarget) {
      scrollTarget.removeEventListener("scroll", preventScrollLockEdge);
    }
  }

  window.addEventListener("load", function () {
    initializeGlobalActivitiesModal();
  });
}();
